var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-card',{staticClass:"mx-auto overflow-hidden",attrs:{"height":"100%","width":"100%"}},[_c('Navbar'),_c('br'),_c('br'),_c('br'),_c('v-card-text',[_c('router-view'),_c('loader')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }